/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { SearchCatalog } from './SearchCatalog'
import {
  SearchCatalogFromJSON,
  SearchCatalogFromJSONTyped,
  SearchCatalogToJSON,
} from './SearchCatalog'

/**
 *
 * @export
 * @interface EnvelopedSearchCatalogCatalogSearchPublic
 */
export interface EnvelopedSearchCatalogCatalogSearchPublic {
  /**
   *
   * @type {SearchCatalog}
   * @memberof EnvelopedSearchCatalogCatalogSearchPublic
   */
  body: SearchCatalog
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedSearchCatalogCatalogSearchPublic
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedSearchCatalogCatalogSearchPublic interface.
 */
export function instanceOfEnvelopedSearchCatalogCatalogSearchPublic(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedSearchCatalogCatalogSearchPublicFromJSON(
  json: any,
): EnvelopedSearchCatalogCatalogSearchPublic {
  return EnvelopedSearchCatalogCatalogSearchPublicFromJSONTyped(json, false)
}

export function EnvelopedSearchCatalogCatalogSearchPublicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedSearchCatalogCatalogSearchPublic {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: SearchCatalogFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedSearchCatalogCatalogSearchPublicToJSON(
  value?: EnvelopedSearchCatalogCatalogSearchPublic | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: SearchCatalogToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
